
export const BoxActive = ({ classNames }) => {

  return (
    <svg className={classNames || ''} width="134" height="176" viewBox="0 0 134 176" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className="dropshape" d="M134 114C134 151 104 176 67 176C30 176 0 151 0 114C0 77 48 28 67 0C85 28 134 77 134 114Z" fill="#004578"/>
      <path className="shineshape" d="M77.51 34.1901C83.57 43.4601 90.16 53.52 96.14 63.77C99.33 69.24 106.14 65.35 102.36 59.93C95.17 49.63 87.2501 39.5001 79.9601 30.1901C76.8701 26.2501 73.8501 22.3901 71.0201 18.6901C68.9101 15.9201 66.5301 17.12 68.3401 20.4C71.0501 25.31 74.85 30.1301 77.51 34.1901Z" fill="#0064A0"/>
    </svg>
  );
};